import { createContext } from 'react';
export const SocketClientContext = createContext({});
